import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/app.css';
import './styles/components.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root missing from index.html');

// The launch screen (index.html) lives inside #root so it shows from the first
// byte. Lift it out before React takes #root over, then fade it away once the
// app has painted — held at least half a second, so it never just flickers.
const launch = container.querySelector<HTMLElement>('.launch');
if (launch) document.body.appendChild(launch);

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (launch) {
  // Plain timers rather than animation frames: frames pause in a background
  // tab, which would leave the launch screen up there indefinitely.
  const hold = Math.max(50, 550 - performance.now());
  window.setTimeout(() => {
    launch.classList.add('launch--done');
    launch.addEventListener('animationend', (e) => e.target === launch && launch.remove());
    // In case the fade never runs (reduced motion, a hidden tab).
    window.setTimeout(() => launch.remove(), 900);
  }, hold);
}
